document.addEventListener('DOMContentLoaded', function () {
  var tabBtn = document.getElementById('offersTabBtn');
  var overlay = document.getElementById('offersModalOverlay');

  if (!tabBtn || !overlay) return;

  // Move both to <body> so fixed positioning is always relative to the real viewport
  document.body.appendChild(tabBtn);
  document.body.appendChild(overlay);

  var closeBtn = document.getElementById('offersModalClose');

  tabBtn.addEventListener('click', function () {
    overlay.classList.add('active');
  });

  closeBtn.addEventListener('click', function () {
    overlay.classList.remove('active');
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      overlay.classList.remove('active');
    }
  });

  document.querySelectorAll('.offers-modal__row[data-code]').forEach(function (row) {
    row.addEventListener('click', function () {
      var code = row.getAttribute('data-code');
      navigator.clipboard.writeText(code);
      var codeEl = row.querySelector('.offers-modal__code');
      var original = codeEl.textContent;
      codeEl.textContent = 'Copied!';
      setTimeout(function () { codeEl.textContent = original; }, 1200);
    });
  });
});